module.exports = __webpack_public_path__ + "static/media/Picture2.23b363a6.jpg";